module.exports = "/images/vendor/jquery-ui-dist/ui-icons_777777_256x240.png?a4c68b5ed915dd5f7ed21c8c33762a38";